<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        그룹
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="dtgTeamId"
                (ngModelChange)="changeTeamInfo($event)">
                <option [ngValue]="''" *ngIf="limitUserGroupId <= 100">전체그룹</option>
                <option [ngValue]="'undefined'">미설정</option>
                <option *ngFor="let item of listTeam;"
                    [ngValue]="item.dtgTeamId">
                    {{item.dtgTeamNm}}
                </option>
            </select>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        권한
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="userGroupId"
                (ngModelChange)="changeUserGroup($event)">
                <option [ngValue]="null">전체권한</option>
                <option *ngFor="let item of listUserGroup;" [ngValue]="item.userGroupId">
                    {{item.userGroupNm}}
                </option>
            </select>
        </div>
    </div>
    <div class="col"></div>
    <div class="col-auto"
        [hidden]="listType === DtgListType.modal">
        <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="clickOpenModalUserInfo(DtgActionType.create,null)">
            <i class="mdi mdi-plus"></i>
            <span class="ml-1">
                사용자추가
            </span>
        </button>
    </div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
            (click)="exportExcel()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">엑셀출력</span>
        </button>
    </div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="">
            <tr>
                <th>
                    소속회사
                </th>
                <th>
                    그룹이름
                </th>
                <th>
                    권한
                </th>
                <th>
                    ID
                </th>
                <th>
                    이름
                </th>
                <th>
                    사용여부
                </th>
                <th [hidden]="listType === DtgListType.modal">
                    편집
                </th>
            </tr>
        </thead>
        <tbody class="text-nowrap">
            <tr *ngFor="let item of listUser;">
                <td>
                    <span>{{item.companyNm}}</span>
                </td>
                <td>
                    <span [hidden]="!item.dtgTeamNm">{{item.dtgTeamNm}}</span>
                    <span [hidden]="item.dtgTeamNm" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <span>{{item.userGroupNm}}</span>
                </td>
                <td>
                    <span [hidden]="listType === DtgListType.modal">{{item.userId}}</span>
                    <button type="button" class="btn btn-sm btn-link px-0"
                        [hidden]="listType === DtgListType.list"
                        (click)="clickSelectUser(item)">
                        <span class="">{{item.userId}}</span>
                    </button>
                </td>
                <td>
                    <span [hidden]="!item.userNm">{{item.userNm}}</span>
                    <span [hidden]="item.userNm" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    {{item.useYn}}
                </td>
                <td [hidden]="listType === DtgListType.modal">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="clickOpenModalUserInfo(DtgActionType.update,item)">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">수정</span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>